import Vue from 'vue'

export default function (context) {
  Vue.directive('can', function (el, binding) {
    if (
      context.app.store.$auth.user?.user_type?.identifier &&
      binding.value === context.app.store.$auth.user.user_type.identifier
    ) {
      return true
    } else {
      return false
    }
  })
  Vue.directive('text-linkify', {
    bind(el, binding) {
      import('dompurify').then(({ default: DOMPurify }) => {
        const sanitizedContent = DOMPurify.sanitize(binding.value)

        const regex = /(https?:\/\/[^\s/$.?#].[^\s]*)/gm

        el.innerHTML = sanitizedContent.replace(regex, match => {
          return `<a href="${match}" target="_blank" rel="noopener noreferrer">${match}</a>`
        })
      })
    },
  })
}
